import styled from "styled-components/macro";

import { calculateRem } from "styles/mixins/calculateRem";

export const StyledTeacherMonitorPage = styled.div`
  margin: ${calculateRem(40)} ${calculateRem(152)} 0 ${calculateRem(152)};
`;
